// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import {
  type AIContextEntity,
  type AIContextPayload,
  ClearAIContext,
  SetAIContext,
} from '@actions/aiContext';

// Types

export interface AIContextState {
  entity: AIContextEntity | null;
  id: string | null;
  name: string | null;
}

type SetAIContextAction = Action<AIContextPayload>;

const initialState: AIContextState = {
  entity: null,
  id: null,
  name: null,
};

export default handleActions<AIContextState, AIContextPayload | void>(
  {
    [SetAIContext.toString()]: (
      _: AIContextState,
      { payload }: SetAIContextAction,
    ): AIContextState => ({
      entity: payload.entity,
      id: payload.id,
      name: payload.name,
    }),
    [ClearAIContext.toString()]: (): AIContextState => initialState,
  },
  initialState,
);
